export default "__VITE_ASSET__BX07uR25__"